import React, { Component, useRef } from 'react';
import '../StoreSelector.css';
import './NewStoreSelector.css';
import { setCursorStyle } from '../../../../utils/MouseUtilities.js';
import Segment from 'semantic-ui-react/dist/es/elements/Segment';
import 'semantic-ui-css/components/segment.min.css';
import 'semantic-ui-css/components/image.min.css';

const hoverCursorStyle = 'pointer';
const unhoverCursorStyle = 'all-scroll';

import { NavigationMenuOptionClicked } from '../../../../utils/Analytics.js';
import SVGImage from '../../image-components/SVGImage';
import { exhibitStoreId, getAllSceneInfoDictAsync } from '../../../../utils/StoreConfigManager';
import { AppContext } from '../../../../AppContext.jsx';
import { ThreeJSWorldContext } from 'web-store-modules/packages/web-store-three-world';
import MenuItem from './MenuItem';
import { storeId } from '../../../../../../variables/Variables';
import { isMobileDevice } from '../../../../utils/DeviceDetector';

const isExhibit = storeId === exhibitStoreId;
const isMobile = isMobileDevice();

class CurrentStoreMenuItem extends Component {
    constructor(props) {
        super(props);

        this.onHover = this.onHover.bind(this);
        this.onUnhover = this.onUnhover.bind(this);
        this.onClick = this.onClick.bind(this);

        this.imageRef = React.createRef();

        this.state = {
            jumpToFont: 'https://s3.amazonaws.com/obsessvr-webstore-assets-public/Caslon-BookItalic.otf',
            placeholderIconSrc: 'https://s3.amazonaws.com/obsessvr-webstore-assets-public/placeholder.svg',
            currentStoreMenuItemColor: '#7d7e7e',
            wallImgUrl: 'https://cdn.obsess-vr.com/umg/',
            arrowPosition: 0
        }
    }

    changeIndex(index) {
        switch(index) {
            case 0:
                this.setState({arrowPosition: '25%'})
              break;
            case 1:
                this.setState({arrowPosition: '46.5%'})
              break;
            case 2:
                this.setState({arrowPosition: '45%'})
                break;
            case 3:
                this.setState({arrowPosition: '70%'})
                break;
            default:
                break;
          }
    }

    onHover(sceneName) {
        this.wallImgUrl = this.wallImgUrl + sceneName.replace(" ", "_").toUpperCase().trim() + '.jpg';
        this.setState({
            wallImgUrl: this.wallImgUrl + sceneName.replace(" ", "_").toUpperCase().trim() + '.jpg'
        })
        setCursorStyle(hoverCursorStyle);
        this.imageRef.current.style.display = 'inline-block';
    }

    onUnhover() {
        this.wallImgUrl = 'https://cdn.obsess-vr.com/umg/';
        setCursorStyle(unhoverCursorStyle);
        this.imageRef.current.style.display = 'none';
    }

    onClick(sceneId) {
        const { threeJSWorldContext, setLoadingIconVisibility, closeMenu } = this.props;
        setLoadingIconVisibility(true);
        closeMenu();
        getAllSceneInfoDictAsync()
            .then(sceneInfoDict => {
                if (!sceneInfoDict[sceneId]) {
                    throw new Error('Scene with id ' + sceneId + ' do not exist!');
                }

                const linkedSceneName = sceneInfoDict[sceneId]['name'];
                let targetPath = '/' + linkedSceneName;
                NavigationMenuOptionClicked(linkedSceneName);

                if (threeJSWorldContext.history.location.pathname !== targetPath) {
                    threeJSWorldContext.pushHistoryWithReset(targetPath)
                } else {
                    this.props.setLoadingIconVisibility(false);
                }
            })
    }

    render() {
        const { currentStoreMenuItemColor, placeholderIconSrc } = this.state;
        const { menuTextFontStyle, store } = this.props;

        let style = Object.assign({}, menuTextFontStyle);
        let sceneStyle = Object.assign({}, menuTextFontStyle);

        style.color = currentStoreMenuItemColor;
        const routeRenders = store.linkedScenes.map((scene, index) => (
            <React.Fragment key={scene.scene_id}>
                <MenuItem
                    handleMouseOver={() => this.onHover(scene.name)}
                    handleMouseOut={this.onUnhover}
                    handleClick={() => this.onClick(scene.scene_id)}
                    menuStyle={sceneStyle}
                    scene={scene}
                    changeIndex={()=>this.changeIndex(index)}
                    index={index}
                />
            </React.Fragment>
        ));

        return (
            <Segment className="overflow-visible">
                <div className="text-align-left float-left">
                    {routeRenders}
                </div>
                {isExhibit && !isMobile && 
                <>
                    <div className='hoverWallImg' style={{top: this.state.arrowPosition}} >
                        <img src={this.wallImgUrl} onError={(event) => event.target.style.display = 'none'} ref={this.imageRef}/>
                    </div>
                </>
                }
                <div
                    style={{ float: 'right', marginTop: '-0.5em' }}
                >
                </div>
            </Segment>
        );
    }
}

CurrentStoreMenuItem.propTypes = {
    closeMenu: PropTypes.func,
    menuTextFontStyle: PropTypes.object,
    store: PropTypes.object,
    setLoadingIconVisibility: PropTypes.func
};

export default props => (
    <AppContext.Consumer>
        {appContextValue => (
            <ThreeJSWorldContext.Consumer>
                {threeJSWorldContext => (
                    <CurrentStoreMenuItem
                        {...props}
                        threeJSWorldContext={threeJSWorldContext}
                        setLoadingIconVisibility={appContextValue.setLoadingIconVisibility}
                    />
                )}
            </ThreeJSWorldContext.Consumer>
        )}
    </AppContext.Consumer>
);
